const slackChannels = {
  alert:
    'https://hooks.slack.com/services/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',
  test:
    'https://hooks.slack.com/services/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',
  coachingChurnThreat:
    'https://hooks.slack.com/services/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',
  coachingRenewalEmailNotice:
    'https://hooks.slack.com/services/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',
  alekTrainer:
    'https://hooks.slack.com/services/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',
  mattTrainer:
    'https://hooks.slack.com/services/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',
  appAlerts:
    'https://hooks.slack.com/services/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',
};

export default slackChannels;
